import { GALLERY_TYPES } from '../constants/proGalleryConstants';
import { CLICKING_ON_ITEM_OPTIONS } from '../constants/settingsConstants';
import { getGalleryInfo } from './gallery/galleryHeight';
import { loadMoreUpdateHeight } from './gallery/galleryLoadMore';
import { getInstagramMediasData } from './services/instagramUserAndMediasService';
import { getMoreHashtags } from './services/hashtagService';
import { openExpandMedia } from './expand/expandActions';
import { getMediasLinksCount } from './services/linksService';
import triggerEvent from './services/biSiteLogger';
import biData from '../bi/feedEvents.json';

import {
  ADD_MEDIAS_DATA,
  UPDATE_MEDIAS_PAGINATION,
  MAX_COUNT_FEED,
} from '../constants';
import store from '../store';

export const eventsListenerProGallery = (eName, eData, type) => (dispatch) => {
  switch (eName) {
    case 'ITEM_CLICKED':
      dispatch(onClickItem(eData, type));
      break;
    case 'CURRENT_ITEM_CHANGED':
      if (eData) dispatch(loadMoreSlider(eData, type));
      break;
    default:
      break;
  }
};

const onClickItem = (eData, type) => (dispatch) => {
  const { clickingOnItem } = store.getState().settingsReducer;

  switch (clickingOnItem) {
    case CLICKING_ON_ITEM_OPTIONS.OPEN_EXPAND:
      dispatch(openExpandMedia({ eData, type }));
      break;
    case CLICKING_ON_ITEM_OPTIONS.OPEN_LINK:
      window.open(eData.linkUrl, '_blank');
      break;
    case CLICKING_ON_ITEM_OPTIONS.NOTHING_APPENED:
      break;
    default:
      break;
  }
};

export const loadMoreSlider = (eData, type) => (dispatch) => {
  const { items, isLoadingMore } = getGalleryInfo(type);
  const currentIndex = items.findIndex(
    (item) => item.originalData.id === eData.originalData.id,
  );
  const needToLoadMore = items.length - 10 <= currentIndex && !isLoadingMore;

  if (needToLoadMore) dispatch(loadMoreMedias(type));
};

export const loadMoreMedias = (type) => (dispatch) => {
  switch (type) {
    case GALLERY_TYPES.FEED:
      dispatch(loadMoreFeed(true));
      break;
    case GALLERY_TYPES.HASHTAG:
      dispatch(loadMoreHashtags(true));
      break;
    default:
      break;
  }
};

export const loadMoreFeed = (isPressLoadMoreBtn) => (dispatch) => {
  biData.CLICK_SHOW_MORE.gallery_type = GALLERY_TYPES.FEED;
  const from = store.getState().appReducer.paginationMedias.after;
  const { typeActionMoreData } = getGalleryInfo(GALLERY_TYPES.FEED);
  const { isLoadingMore } = getGalleryInfo(GALLERY_TYPES.FEED);

  if (isLoadingMore) return;
  if (from) {
    dispatch({
      type: typeActionMoreData,
      payload: {
        isLoadingMore: true,
      },
    });

    if (isPressLoadMoreBtn) {
      dispatch(loadMoreUpdateHeight(GALLERY_TYPES.FEED));
      triggerEvent(biData.CLICK_SHOW_MORE);
    }

    return getInstagramMediasData(from, MAX_COUNT_FEED).then(
      ({ medias, pagination }) => {
        dispatch({
          type: ADD_MEDIAS_DATA,
          payload: medias,
        });
        dispatch({
          type: UPDATE_MEDIAS_PAGINATION,
          payload: pagination,
        });
        dispatch({
          type: typeActionMoreData,
          payload: {
            isLoadingMore: false,
          },
        });

        dispatch(getMediasLinksCount(medias));
        return { pagination };
      },
    );
  } else if (isPressLoadMoreBtn) {
    dispatch(loadMoreUpdateHeight(GALLERY_TYPES.FEED));
    triggerEvent(biData.CLICK_SHOW_MORE);
  }
  return;
};

export const loadMoreHashtags = (isPressLoadMoreBtn) => (dispatch) => {
  biData.CLICK_SHOW_MORE.gallery_type = GALLERY_TYPES.HASHTAG;
  const { typeActionMoreData } = getGalleryInfo(GALLERY_TYPES.HASHTAG);
  const { hashtags, defaultHashtags } = store.getState().appReducer;
  const { isLoadingMore } = getGalleryInfo(GALLERY_TYPES.HASHTAG);

  if (isLoadingMore) return;
  const isDefault = hashtags.length === 0;
  const currentHashtags = isDefault ? defaultHashtags : hashtags;

  const hashtagsHaveMoreMedias = currentHashtags.filter((hashtag) => {
    return hashtag && hashtag.pagination && hashtag.pagination.after;
  });

  if (hashtagsHaveMoreMedias.length) {
    dispatch({
      type: typeActionMoreData,
      payload: {
        isLoadingMore: true,
      },
    });

    dispatch(
      getMoreHashtags(hashtagsHaveMoreMedias, isDefault, typeActionMoreData),
    );

    if (isPressLoadMoreBtn) {
      dispatch(loadMoreUpdateHeight(GALLERY_TYPES.HASHTAG));
      triggerEvent(biData.CLICK_SHOW_MORE);
    }
  } else if (isPressLoadMoreBtn) {
    dispatch(loadMoreUpdateHeight(GALLERY_TYPES.HASHTAG));
    triggerEvent(biData.CLICK_SHOW_MORE);
  }
};
